export default class FasciaPromoSignup {
    constructor(node) {
        this.node = node;
        this.formNode = node.querySelector('form');
        
        this.settings = window.fasciaPromoSignupSettings;
        
        this.addListeners();
    }

    static init() {
        let fasciaNode = document.querySelector("[data-fascia-promo-signup]");

        if (fasciaNode) {
            return new FasciaPromoSignup(fasciaNode);
        }
    }
    
    addListeners() {
        let _this = this;

        $(this.formNode).validate({
            callbackHandler: function (data, form)
            {
                _this.formNode.querySelector('.response-text').innerHTML = data.d.HTML;
                if (data.d.Status)
                    _this.formNode.querySelector('input[type="submit"]').style.display = 'none';
            }
        });
    }
}